import { render, staticRenderFns } from "./UpdatePaymentDetails.vue?vue&type=template&id=40b467bc&scoped=true&"
import script from "./UpdatePaymentDetails.vue?vue&type=script&lang=js&"
export * from "./UpdatePaymentDetails.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePaymentDetails.vue?vue&type=style&index=0&id=40b467bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b467bc",
  null
  
)

export default component.exports